// extracted by mini-css-extract-plugin
export default {"selectedGuestRowDelete":"DeleteButton_selectedGuestRowDelete__olBz9","selectedGuestRowDeleteIcon":"DeleteButton_selectedGuestRowDeleteIcon__dlK3t"};